import {IContact} from "../../Components/Hub/Interfaces/IContact";
import MailAvatar from "../CustomOdx/MailAvatar";
import OdxChip from "../NativeOdx/Odx-Chip";
import {odxVariants} from "../constants";
import * as React from "react";
import {simplifyForHtmlId} from "../../Utils/transformer";

interface ProjectCardProps {
    title: string,
    description: string,
    imageBase64?: string,
    imageSrc?: string,
    mode: "project" | "module",
    numberOfModules: number,
    contacts?: IContact[]
    forceSmallIcon?: boolean,
    onClick?: () => void,
    source: string,
    isAdmin: boolean // Add isAdmin prop to determine user role
    key: number,
    idPrefix?: string
}

const AppProjectsCard: React.FC<ProjectCardProps> = ({
                                                         title,
                                                         description,
                                                         imageBase64,
                                                         imageSrc,
                                                         numberOfModules,
                                                         mode,
                                                         contacts,
                                                         forceSmallIcon = false,
                                                         onClick,
                                                         source,
                                                         isAdmin, // Receive isAdmin prop
                                                         key,
                                                         idPrefix
                                                     }) => {
    // Chip for number of modules/projects
    let chipContent = <></>;
    const moduleCountChipId = idPrefix ? `${idPrefix}-module-count` : undefined;

    switch (mode) {
        case "project":
            chipContent = numberOfModules === -1 ? <OdxChip size={"small"} id={moduleCountChipId} content={"Loading"}/> :
                numberOfModules === 0 ? <OdxChip size={"small"} id={moduleCountChipId} content={"No modules used"}/> :
                    numberOfModules === 1 ? <OdxChip size={"small"} id={moduleCountChipId} content={"1 module used"}/> :
                        <OdxChip size={"small"} id={moduleCountChipId} content={`${numberOfModules} modules used`}/>;
            break;
        case "module":
            chipContent = numberOfModules === -1 ? <OdxChip size={"small"} id={moduleCountChipId} content={"Loading"}/> :
                numberOfModules === 0 ? <OdxChip size={"small"} id={moduleCountChipId} content={"Not used yet"}/> :
                    numberOfModules === 1 ? <OdxChip size={"small"} id={moduleCountChipId} content={"1 Instance"}/> :
                        <OdxChip size={"small"} id={moduleCountChipId} content={`${numberOfModules} Instances`}/>;
            break;
    }

    const shortenDescription = (description: string) => {
        return description.length > 100 ? description.substring(0, 100) + "..." : description;
    }

    // Determine the display value for the source chip
    const displaySource = source ? source : 'legacy';

    return (
        <div
            className="odx-card--launch-tile odx-cdk-interactive odx-card !flex flex-col h-full !w-full"
            onClick={onClick}
            id={idPrefix ? `${idPrefix}-card` : undefined}
        >
            <div className="odx-card__container !pt-3 !pb-1 grow">
                <div className={"flex w-full"}>
                    <div className={"w-fit !pr-[16px]"}>
                        <odx-avatar
                            size="xxl"
                            shape="circle"
                            variant="ghost"
                            className="flex items-center justify-center"
                            style={{"--size": forceSmallIcon ? "42px" : "64px"} as React.CSSProperties}
                            key={key}
                            id={idPrefix ? `${idPrefix}-avatar` : undefined}
                        >
                            {imageBase64 || imageSrc ? (
                                <img
                                    src={imageBase64 ? `data:image/jpeg;base64,${imageBase64}` : imageSrc}
                                    alt={`${title} icon`}
                                    className="object-cover !w-[70%] !h-[70%]"
                                />
                            ) : (
                                <odx-icon name="core::folder" size="xxl"></odx-icon>
                            )}
                        </odx-avatar>
                    </div>
                    <div className={"w-full"}>
                        <div className={"odx-card__content w-full !flex h-full"}>
                            <div
                                className={"odx-card__title"}
                                id={idPrefix ? `${idPrefix}-title` : undefined}
                            >
                                {title}
                            </div>
                            <div
                                className={"odx-card__subtitle"}
                                id={idPrefix ? `${idPrefix}-description` : undefined}
                            >
                                {shortenDescription(description)}
                            </div>
                            <div className={"!pb-5 !pt-5 grow flex"}>
                                <div className={"flex grow"}>
                                    <div className={"flex-1 flex-grow self-end"}>
                                        <div className="flex space-x-2">
                                            {chipContent}
                                            {isAdmin && ( // Only display source chip for admin users
                                                <OdxChip
                                                    size={"small"}
                                                    content={"Source: " + displaySource}
                                                    variant={odxVariants.secondary}
                                                    id={idPrefix ? `${idPrefix}-source` : undefined}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className={"right-0 self-end flex !-space-x-5"}>
                                        {contacts && contacts.map((contact, index) => (
                                            <MailAvatar size={"small"}
                                                        variant={"circle"}
                                                        mail={contact.mail}
                                                        key={index + key * 1000}
                                                        forceSmallIcon={true}
                                                        className={`relative z-${500 - index * 10} hover:z-50`}
                                                        id={idPrefix ? `${idPrefix}-contact-${simplifyForHtmlId(contact.mail ?? `contact-${index}`)}` : undefined}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default AppProjectsCard;
